import { render } from "./ControleMudancaAuditor.vue?vue&type=template&id=37dba500&scoped=true"
import script from "./ControleMudancaAuditor.vue?vue&type=script&lang=js"
export * from "./ControleMudancaAuditor.vue?vue&type=script&lang=js"

import "./ControleMudancaAuditor.vue?vue&type=style&index=0&id=37dba500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dba500"]])

export default __exports__